//
// isoDatetimeUtc
//
// Returns current datetime in ISO 8601 format with UTC timezone
// Adds an offset in seconds
//
// digits: digits after the seconds position (0, 1, or 3)
//   0 = no fractional seconds: "2025-02-11T14:37:29Z"
//   1 = tenths: "2025-02-11T14:37:29.5Z"
//   3 = milliseconds: "2025-02-11T14:37:29.500Z"
//

export default (secondsOffset = 0, digits = 0) => {
  const timedate = new Date();
  timedate.setSeconds(timedate.getSeconds() + secondsOffset);

  // if (timedate) return timedate.toISOString().replace('Z', '000Z');

  if (digits === 0) {
    // No fractional seconds: "2025-02-11T14:37:29Z"
    return `${timedate.toISOString().slice(0, 19)}Z`;
  }

  // With fractional seconds: "2025-02-11T14:37:29.500Z"
  const length = 20 + digits;
  return `${timedate.toISOString().slice(0, length)}Z`;
};
